import { Injectable, Inject } from '@angular/core';
import { get } from 'lodash';
import { OrderDetailsMapped } from '../option-order/_interfaces_/option-order-details.mapped.interface';
import { BookedFlightMapped } from '../flight/_interfaces_/booked-flight.mapped.interface';
import { PassengerMapped, FrequentFlyerMapped, SelectedBaggageServiceMapped, SelectedAirportAssistanceServiceMapped } from './_interfaces_/passenger.mapped.interface';
import { Passenger, FrequentFlyer, SelectedAncillaryServices } from './_interfaces_/passenger.interface';
import { SelectedPersonMapperService } from '../selected-person/selected-person-mapper.service';

@Injectable({
  providedIn: 'root'
})
export class PassengerMapperService {
  constructor(@Inject(SelectedPersonMapperService) private _selectedPersonMapperService: SelectedPersonMapperService) {}

  mapPassengers(passengers: Passenger[]): PassengerMapped[] {
    return passengers.map(passenger => this.mapPassenger(passenger));
  }

  mapPassenger(passenger: Passenger): PassengerMapped {
    return {
      id: passenger.identifier,
      paxType: passenger.paxType,
      selectedPerson: this._selectedPersonMapperService.mapSelectedPerson(passenger.selectedPerson),
      frequentFlyer: this.mapFrequentFlyer(passenger.frequentFlyer),
      selectedBaggageServices: this.mapSelectedBaggage(passenger.selectedAncillaryServices),
      selectedSeatPreference: get(passenger, 'selectedSeatPreference.code', null),
      selectedMealPreference: get(passenger, 'selectedMealPreference.code', null),
      selectedAirportAssistanceServices: this.mapSelectedAirportAssistanceServices(passenger.selectedAncillaryServices)
    };
  }

  mapFrequentFlyer(frequentFlyer: FrequentFlyer | null): FrequentFlyerMapped {
    if (!frequentFlyer) {
      return null;
    }
    return {
      airlineCode: frequentFlyer.airlineCode,
      frequentFlyerNumber: frequentFlyer.frequentFlyerNumber
    };
  }

  mapSelectedBaggage(services: SelectedAncillaryServices): SelectedBaggageServiceMapped[] {
    const baggages = services.selectedBaggageServices;

    if (!baggages || baggages.length === 0) {
      return null;
    }

    return baggages.map(baggage => ({
      name: baggage.displayName,
      code: baggage.code,
      weight: baggage.weight
    }));
  }

  mapSelectedAirportAssistanceServices(services: SelectedAncillaryServices): SelectedAirportAssistanceServiceMapped[] {
    const assistanceServices = services.selectedAirportAssistanceServices;

    if (!assistanceServices || assistanceServices.length === 0) {
      return null;
    }

    return assistanceServices.map(service => ({
      DisplayName: service.displayName,
      Code: service.code
    }));
  }
  enhancePassengersWithFrequentFlyer(orderDetails: OrderDetailsMapped, bookedFlight: BookedFlightMapped): void {
    if (orderDetails?.bookedFlight?.passengersWithExtrasInfo && bookedFlight?.passengers) {
      orderDetails.bookedFlight.passengersWithExtrasInfo.forEach(passenger => {
        const originalPassenger = bookedFlight.passengers.find(p =>
          p.selectedPerson?.firstName === passenger.firstName &&
          p.selectedPerson?.lastName === passenger.lastName
        );
        
        if (originalPassenger?.frequentFlyer) {
          passenger.frequentFlyer = originalPassenger.frequentFlyer;
        }
      });
    }
  }
}
